import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { format, isValid, parse } from "date-fns";
/** Default date-fns display format per field type, used when none is supplied. */
export var DEFAULT_DISPLAY_FORMATS = {
  single: "MMM d, yyyy",
  datetime: "MMM d, yyyy HH:mm",
  range: "MMM d, yyyy"
};

/** Parses a canonical 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:mm' string into a local Date, or null. */
export function parseCanonical(value) {
  if (!value) return null;
  var _value$split = value.split("T"),
    _value$split2 = _slicedToArray(_value$split, 2),
    datePart = _value$split2[0],
    timePart = _value$split2[1];
  var _datePart$split$map = datePart.split("-").map(Number),
    _datePart$split$map2 = _slicedToArray(_datePart$split$map, 3),
    year = _datePart$split$map2[0],
    month = _datePart$split$map2[1],
    day = _datePart$split$map2[2];
  if (!year || !month || !day) return null;
  var date = new Date(year, month - 1, day);
  if (timePart) {
    var _timePart$split$map = timePart.split(":").map(Number),
      _timePart$split$map2 = _slicedToArray(_timePart$split$map, 2),
      hours = _timePart$split$map2[0],
      minutes = _timePart$split$map2[1];
    date.setHours(hours || 0, minutes || 0, 0, 0);
  }
  return date;
}

/** Serializes a Date to canonical 'YYYY-MM-DD' using local parts, or '' when null. */
export function toCanonicalDate(date) {
  if (!date) return "";
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var day = String(date.getDate()).padStart(2, "0");
  return "".concat(year, "-").concat(month, "-").concat(day);
}

/** Serializes a Date to canonical 'YYYY-MM-DDTHH:mm' using local parts, or '' when null. */
export function toCanonicalDateTime(date) {
  if (!date) return "";
  var hours = String(date.getHours()).padStart(2, "0");
  var minutes = String(date.getMinutes()).padStart(2, "0");
  return "".concat(toCanonicalDate(date), "T").concat(hours, ":").concat(minutes);
}

/** Formats a Date for display using a date-fns token string, or '' when null. */
export function formatDisplay(date, displayFormat) {
  return date ? format(date, displayFormat) : "";
}

/** Formats a [start, end] pair as a joined display string, or '' when incomplete. */
export function formatRangeDisplay(start, end, displayFormat) {
  if (!start || !end) return "";
  return "".concat(formatDisplay(start, displayFormat), " \u2013 ").concat(formatDisplay(end, displayFormat));
}

/** Parses user-typed text against a date-fns format, returning a valid Date or null. */
export function parseTypedDate(text, displayFormat) {
  if (!text.trim()) return null;
  var parsed = parse(text, displayFormat, new Date());
  return isValid(parsed) ? parsed : null;
}